import _ from 'underscore'
import Backbone from 'backbone'
import SchoolViewTemplate from '../templates/school.tpl'
import HeaderView from './header'
import NavView from './nav'
import user from '../user'
import config from '../config'
import UserModel from '../models/user'
import StudentView from './student'
import TeacherView from './teacher'
import EditSchoolView from './edit-school'
import CreateClassView from './create-class'
import ClassModel from '../models/class'
import SchoolNameView from './school-name'
import SchoolPinView from './school-pin'
import AddUserView from './add-user'

const SchoolView = Backbone.View.extend({
    el: '#current-view',
    tagName: 'div',
    id: 'school-view',
    events: {
        'click .edit-school': 'editSchool',
        'click .add-teacher': 'addTeacher',
        'click .add-student': 'addStudent',
        'click .create-class': 'createClass',
    },
    initialize() {
        this.template = _.template(SchoolViewTemplate)
    },
    render() {
        if (user.get('role').get('name') === 'standard') {
           config.get('navItems').each((navItemModel) => {
                if (navItemModel.get('name') === 'menu') {
                    navItemModel.set({active: true})
                } else {
                    navItemModel.set({active: false})
                }
            })
            return false
        }

        this.$el.html(this.template(this.model.toJSON()))

        const headerView = new HeaderView()
        this.$('#header-view').append(headerView.render().el)

        const navView = new NavView()
        this.$('#nav-view').append(navView.render().el)

        const schoolNameView = new SchoolNameView({model: this.model.get('school')})
        this.$('.userm-school-name').append(schoolNameView.render().el)

        const schoolPinView = new SchoolPinView({model: this.model.get('school')})
        this.$('.userm-pin-wrapper').append(schoolPinView.render().el)

        // load the teacher view
        if (user.get('role').get('name') !== 'advanced') {
            const teacherView = new TeacherView()
            this.$('.teacher').append(teacherView.render().el)
        } else {
            this.$('.contm-users-tab-right').addClass('full-width')
            this.$('.student').addClass('full-width')
        }

        // load the student view
        const studentView = new StudentView()
        this.$('.student').append(studentView.render().el)

        return this
    },
    editSchool() {
        const editSchoolView = new EditSchoolView({model: this.model})
        this.$('#form-wrapper').html(editSchoolView.render().el)
    },
    addTeacher() {
        const teacherModel = new UserModel({id: 1})
        teacherModel.set({
            email: '',
            school: {
                id: this.model.get('school').get('id'),
                pin: this.model.get('school').get('pin'),
            },
            type: {
                name: 'teacher',
            },
            role: {
                name: 'standard',
            }
        })

        const addUserView = new AddUserView({model: teacherModel, schoolView: this})
        this.$('#form-wrapper').html(addUserView.render().el)
    },
    addStudent() {
        const studentModel = new UserModel({id: 1})
        studentModel.set({
            school: {
                id: this.model.get('school').get('id'),
                pin: this.model.get('school').get('pin'),
            },
            type: {
                name: 'student',
            }
        })

        const addUserView = new AddUserView({model: studentModel, schoolView: this})
        this.$('#form-wrapper').html(addUserView.render().el)
    },
    createClass() {
        const createClassView = new CreateClassView({model: new ClassModel(), schoolView: this})
        this.$('#form-wrapper').html(createClassView.render().el)
    }
})

export default SchoolView
